import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../../global/config/app.config';
import { APP_CONFIG } from '../../global/config/config.token';
import { Router } from '@angular/router';
import { BatchDetails, DepositBatchDropdownResponse, DepositBatchModel, DonationBatchLookups, EditDonationBatchSearchFiltersVM, SelectListItem } from '../models/DonationBatchModels';
import { SearchModel } from '../../global/model/SearchModel';
export interface BatchLookups {
  checkbookOptions: string[];
  batchTypeOptions: string[];
  periodOptions: string[];
}

@Injectable({
  providedIn: 'root'
})
export class BatchService {
  constructor(
    private httpClient: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig,
    private router: Router
  ) { }

  getBatchDetails = (depositBatchId: number, campaignId: number): Observable<BatchDetails> => {
    const url = `${this.config.apiUrl}DonationBatch/details/${depositBatchId}?campaignId=${campaignId}`;
    return this.httpClient.get<BatchDetails>(url, { withCredentials: true });
  };

  saveBatchDetails = (batchDetails: BatchDetails, campaignId: number): Observable<any> => {
    const url = `${this.config.apiUrl}DonationBatch/update-donation-batch?campaignId=${campaignId}`;
    batchDetails.campaignId = campaignId;
    return this.httpClient.post(url, batchDetails, { withCredentials: true });
  };

  //getBatchLookups = (campaignId: number): Observable<DepositBatchDropdownResponse> => {
  //  const url = `${this.config.apiUrl}lookups/batch-all?campaignId=${campaignId}`;
  //  return this.httpClient.get<DepositBatchDropdownResponse>(url, { withCredentials: true });
  //};

  getBatchSearchColumnsAndFilters = (campaignId: number): Observable<SearchModel> => {
    const url = `${this.config.apiUrl}DonationBatch/donation-batch-columns?campaignId=${campaignId}`;
    return this.httpClient.get<SearchModel>(url, { withCredentials: true });
  }

  getEditDonationBatchSearchFilters = (campaignId: number): Observable<EditDonationBatchSearchFiltersVM> => {
    const url = `${this.config.apiUrl}DonationBatch/edit-donation-batch-filters?campaignId=${campaignId}`;
    return this.httpClient.get<EditDonationBatchSearchFiltersVM>(url, { withCredentials: true });
  }

  getAddDonationBatchLookups = (campaignId: number): Observable<DepositBatchDropdownResponse> => {
    const url = `${this.config.apiUrl}DonationBatch/add-donation-batch-lookups?campaignId=${campaignId}`;
    return this.httpClient.get<DepositBatchDropdownResponse>(url, { withCredentials: true });
  }

  addDonationBatch = (batchModel: DepositBatchModel): Observable<any> => {
    const url = `${this.config.apiUrl}DonationBatch/add-donation-batch`;
    return this.httpClient.post(url, batchModel, { withCredentials: true });
  }

  getCheckbooksByFundCode(fundCodeId: number): Observable<SelectListItem[]> {
    const url = `${this.config.apiUrl}DonationBatch/fundcode-to-checkbooks?fundcodeId=${fundCodeId}`;
    return this.httpClient.get<SelectListItem[]>(url, { withCredentials: true });
  }

  getFundCodesByChildCampaign(childCampaignId: number): Observable<SelectListItem[]> {
    const url = `${this.config.apiUrl}DonationBatch/get-child-campaign-fundcodes?childCampaignId=${childCampaignId}`;
    return this.httpClient.get<SelectListItem[]>(url, { withCredentials: true });
  }

  searchDonationBatches(params: { campaignId: number; searchFilters: string }) {
    const url = `${this.config.apiUrl}DonationBatch/donation-batch-search`;
    return this.httpClient.get<any>(url, {params, withCredentials: true });
  }

  deleteDonationBatch(batchId: number): Observable<any> {
    const url = `${this.config.apiUrl}DonationBatch/delete-donation-batch?batchId=${batchId}`;
    return this.httpClient.delete<any>(url, { withCredentials: true });
  }

  getUnbatchedDonations(campaignId: number, filterViewModel: any): Observable<any[]> {
    const payload = {
      CampaignId: campaignId,
      DonationID: filterViewModel.DonationID || '',
      Address: filterViewModel.Address || '',
      Donor: filterViewModel.Donor || '',
      Source: filterViewModel.Source?.join(',') || '',
      Type: filterViewModel.Type?.join(',') || '',
      Fund: filterViewModel.Fund?.join(',') || '',
      EnteredBy: filterViewModel.EnteredBy || '',
      LineNumber: filterViewModel.LineNumber || '',
      DonationDate: filterViewModel.DonationDate || '',
      DonationAmount: filterViewModel.DonationAmount || '',
      // Donation Date filter
      DonationDateFrom: filterViewModel.DonationDate?.from || '',
      DonationDateTo: filterViewModel.DonationDate?.to || '',
      DonationDateOperator: filterViewModel.DonationDate?.op || 'equals',

      // Donation Amount filter
      DonationAmountFrom: filterViewModel.Amount?.from || '',
      DonationAmountTo: filterViewModel.Amount?.to || '',
      DonationAmountOperator: filterViewModel.Amount?.op || 'equals'
    };
    const url = `${this.config.apiUrl}DonationBatch/unbatched-donations`;
    return this.httpClient.get<any[]>(url, { withCredentials: true, params: payload });
  }

  getBatchedDonations(depositBatchId: number, filterViewModel: any): Observable<any[]> {
    const payload = {
      DepositBatchId: depositBatchId,
      DonationID: filterViewModel.DonationID || '',
      Address: filterViewModel.Address || '',
      Donor: filterViewModel.Donor || '',
      Source: filterViewModel.Source?.join(',') || '',
      Type: filterViewModel.Type?.join(',') || '',
      Fund: filterViewModel.Fund?.join(',') || '',
      EnteredBy: filterViewModel.EnteredBy || '',
      LineNumber: filterViewModel.LineNumber || '',
      DonationDate: filterViewModel.DonationDate || '',
      DonationAmount: filterViewModel.DonationAmount || '',
          // Donation Date filter
      DonationDateFrom: filterViewModel.DonationDate?.from || '',
      DonationDateTo: filterViewModel.DonationDate?.to || '',
      DonationDateOperator: filterViewModel.DonationDate?.op || 'equals',

      // Donation Amount filter
      DonationAmountFrom: filterViewModel.Amount?.from || '',
      DonationAmountTo: filterViewModel.Amount?.to || '',
      DonationAmountOperator: filterViewModel.Amount?.op || 'equals'
    };
    const url = `${this.config.apiUrl}DonationBatch/batched-donations?DepositBatchId=${depositBatchId}`;
    return this.httpClient.get<any[]>(url, { withCredentials: true, params: payload });
  }

  deleteDonationsFromBatch(batchId: number, donationIds: number[]): Observable<any> {
    const url = `${this.config.apiUrl}DonationBatch/${batchId}/donations/delete`;
    return this.httpClient.post(url, donationIds, { withCredentials: true });
  }

  addDonationsToBatch(batchId: number, donationIds: number[]): Observable<any> {
    const url = `${this.config.apiUrl}DonationBatch/${batchId}/add-donations`;
    return this.httpClient.post(url, donationIds, { withCredentials: true });
  }

  getBatchedControls(depositBatchId: number): Observable<any[]> {
    const url = `${this.config.apiUrl}DonationBatch/GetDonationBatchControls/${depositBatchId}`;
    return this.httpClient.get<any[]>(url, { withCredentials: true });
  }

  approveBatches(batchIds: number[]): Observable<any> {
    const url = `${this.config.apiUrl}DonationBatch/approve-donation-batches`;
    return this.httpClient.post(url, batchIds, { withCredentials: true });
  }

  unapproveBatches(batchIds: number[]): Observable<any> {
    const url = `${this.config.apiUrl}DonationBatch/unapprove-donation-batches`;
    return this.httpClient.post(url, batchIds, { withCredentials: true });
  }

  deleteBatches(batchIds: number[]): Observable<any> {
    const url = `${this.config.apiUrl}DonationBatch/delete-donation-batches`;
    return this.httpClient.request('delete', url, {
      body: batchIds,
      withCredentials: true
    });
  }


}
